(function () {
 'use strict';
 const states = new Map();
 const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
 const mobile = window.matchMedia('(max-width: 640px)');
 function initialize(root) {
  root.querySelectorAll('[data-search-typing]').forEach(function (input) {
   if (states.has(input)) return;
   let terms;
   try { terms = JSON.parse(input.dataset.searchTerms || '[]'); } catch (_) { return; }
   if (!terms.length) return;
   const base = input.dataset.searchBase || input.placeholder;
   let timer, word = 0, letter = 0, deleting = false;
   function stop() { window.clearTimeout(timer); input.placeholder = base + ' ' + terms[0]; }
   function eligible() { return input.isConnected && !document.hidden && !motion.matches && document.activeElement !== input && !input.value; }
   function tick() {
    if (!eligible()) { stop(); return; }
    const term = terms[word];
    letter += deleting ? -1 : 1;
    input.placeholder = base + (letter ? ' ' + term.slice(0, letter) : '');
    let delay = deleting ? 65 : 110;
    if (letter === term.length) {
     timer = window.setTimeout(function () {
      if (!eligible()) { stop(); return; }
      letter = 0; input.placeholder = base;
      timer = window.setTimeout(tick, 110);
     }, 2000);
     return;
    }
    else if (deleting && letter === 0) { deleting = false; word = (word + 1) % terms.length; delay = 500; }
    timer = window.setTimeout(tick, delay);
   }
   function start() { stop(); word = 0; letter = 0; deleting = false; if (eligible()) { input.placeholder = base; timer = window.setTimeout(tick, 900); } }
   input.addEventListener('focus', stop);
   input.addEventListener('input', stop);
   input.addEventListener('blur', start);
   states.set(input, { start: start, stop: stop });
   start();
  });
 }
 function refresh() { states.forEach(function (state, input) { if (!input.isConnected) { state.stop(); states.delete(input); } else state.start(); }); }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
 else initialize(document);
 document.addEventListener('visibilitychange', refresh);
 motion.addEventListener('change', refresh);
 mobile.addEventListener('change', refresh);
 document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
 document.addEventListener('shopify:section:unload', function (event) { states.forEach(function (state, input) { if (event.target.contains(input)) { state.stop(); states.delete(input); } }); });
})();
